export const mockData = {
  companyInfo: {
    name: "Iversen Drift & Vedlikehold",
    tagline: "Din pålitelige vaktmester i Bergen",
    description: "Fra små reparasjoner til større vedlikeholdsoppdrag – vi fikser det meste med profesjonalitet og omhu",
    phone: "+47 123 45 678",
    email: "post@iversendrift.no",
    address: "Bergen, Norge",
    hourlyRate: 950
  },
  services: [
    {
      id: 1,
      title: "Reparasjon & Vedlikehold",
      description: "Alt fra små til større reparasjoner. Vi fikser knekte møbler, ødelagte skap, fester dørhåndtak og mye mer.",
      icon: "wrench",
      available: true
    },
    {
      id: 2,
      title: "Høytrykksvask",
      description: "Profesjonell høytrykksrens av uteområder, terrasser, innkjørsler og fasader.",
      icon: "spray-can",
      available: true
    },
    {
      id: 3,
      title: "Saltstrøing Vinter",
      description: "Trygg ferdsel gjennom vinteren. Vi sørger for saltstrøing av uteområder.",
      icon: "snowflake",
      available: true
    },
    {
      id: 4,
      title: "Låsetjenester",
      description: "Skifte av låser, låsesmøring og generelt vedlikehold av låsesystemer.",
      icon: "key",
      available: true
    },
    {
      id: 5,
      title: "Gressklipping",
      description: "Kommer snart – tilgjengelig når vi har fått bil.",
      icon: "leaf",
      available: false
    },
    {
      id: 6,
      title: "Snørydding",
      description: "Kommer snart – tilgjengelig når vi har fått bil.",
      icon: "cloud-snow",
      available: false
    }
  ],
  features: [
    {
      title: "Rask respons",
      description: "Vi svarer raskt på henvendelser og kommer når det passer deg"
    },
    {
      title: "Konkurransedyktige priser",
      description: "Gode priser på alle tjenester uten å gå på kompromiss med kvalitet"
    },
    {
      title: "Erfaring",
      description: "Solid erfaring med alle typer vaktmester- og vedlikeholdsoppgaver"
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Kari Johansen",
      location: "Bergen sentrum",
      rating: 5,
      text: "Fantastisk service! Fikset alt jeg trengte hjelp til på kort varsel. Anbefales på det varmeste.",
      service: "Reparasjon & Vedlikehold"
    },
    {
      id: 2,
      name: "Ole Hansen",
      location: "Åsane",
      rating: 5,
      text: "Profesjonelt arbeid med høytrykksvasken. Terrassen ser ut som ny!",
      service: "Høytrykksvask"
    },
    {
      id: 3,
      name: "Linda Berg",
      location: "Fyllingsdalen",
      rating: 5,
      text: "Ryddig, punktlig og gode priser. Kommer garantert til å bruke Iversen igjen.",
      service: "Saltstrøing"
    }
  ],
  faqs: [
    {
      id: 1,
      question: "Hvor raskt kan dere komme?",
      answer: "Vi svarer normalt innen 2 timer i åpningstiden. For akutte oppdrag kan vi ofte komme samme dag eller neste dag, avhengig av tilgjengelighet."
    },
    {
      id: 2,
      question: "Hva koster tjenestene deres?",
      answer: "Vi jobber med timepris på 950 kr. Ved bruk av booking-systemet vårt får du automatisk et estimat basert på oppdragsbeskrivelsen. Vi gir alltid et endelig pristilbud før arbeidet starter."
    },
    {
      id: 3,
      question: "Dekker dere hele Bergen?",
      answer: "Ja, vi dekker Bergen og nærområdene. For oppdrag utenfor Bergen sentrum kan det tilkomme kjøregodtgjørelse som vi informerer om på forhånd."
    },
    {
      id: 4,
      question: "Må jeg være hjemme under arbeidet?",
      answer: "Det kommer an på oppdraget. For de fleste utvendige jobber trenger vi ikke at du er tilstede. Vi diskuterer dette ved booking."
    },
    {
      id: 5,
      question: "Hva skjer hvis været er dårlig?",
      answer: "For utendørs arbeid som høytrykksvask kan vi måtte utsette ved kraftig regnvær. Vi kontakter deg så raskt som mulig hvis vi må endre avtalen."
    }
  ]
};
